module.exports = __webpack_public_path__ + "static/media/bff12.87f564aa.png";